import { useMutation, useQueryClient } from "@tanstack/react-query";
import { StreamsCategories } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { KEY_PREFIX } from "components/streams/hooks/useStreams";
const useStreamCategoryMutation = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ streamId, categories }) => StreamsCategories.updateStreamCategories(streamId, categories),
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.stream_categories_updated", { ns: "enterprise_illuminate" }),
        i18n.t("notifications.success_title", { ns: "enterprise_illuminate" })
      );
      queryClient.invalidateQueries({ queryKey: KEY_PREFIX });
    },
    onError: (error) => {
      UserNotification.error(
        i18n.t("notifications.stream_categories_update_failed", { ns: "enterprise_illuminate", error: error.message })
      );
    }
  });
  return { updateCategories: mutation };
};
export default useStreamCategoryMutation;
